var cov_1s4iae33rq = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Drawer/index.tsx",
      hash = "71f3f9fd41255cfd184470b3059219d837075d20",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Drawer/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 15
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "1": {
        start: {
          line: 5,
          column: 39
        },
        end: {
          line: 5,
          column: 66
        }
      },
      "2": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "3": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 37
        }
      },
      "4": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 15
          },
          end: {
            line: 5,
            column: 16
          }
        },
        loc: {
          start: {
            line: 5,
            column: 39
          },
          end: {
            line: 5,
            column: 66
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Drawer/index.tsx";

import React from 'react';
import Modal from '../Modal';
cov_1s4iae33rq.s[0]++;

var Drawer = function Drawer(props) {
  cov_1s4iae33rq.f[0]++;
  cov_1s4iae33rq.s[1]++;
  return (
    /*#__PURE__*/
    React.createElement(Modal, Object.assign({}, props, {
      drawer: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 5,
        columnNumber: 40
      }
    }))
  );
};

cov_1s4iae33rq.s[2]++;
Drawer.defaultProps = {
  position: 'right',
  width: 'auto'
};
cov_1s4iae33rq.s[3]++;
Drawer.displayName = 'ShineoutDrawer';
cov_1s4iae33rq.s[4]++;
Drawer.Submit = Modal.Submit;
export default Drawer;